import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getStreetsByCityId } from '../addressService'

export function useStreetsByCityId(cityId: number | null, enabled: boolean) {
  return useQuery({
    queryKey: [QUERY_KEYS.PLACES_STREETS, cityId],
    queryFn: () => getStreetsByCityId(cityId!),
    enabled: enabled && cityId != null,
  })
}
